import './application.css'
import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import { Agentation } from 'agentation'
import { ToastProvider } from '@/components/ui/Toast'

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob(['../pages/**/*.tsx'], { eager: true })
    return pages[`../pages/${name}.tsx`]
  },
  setup({ el, App, props }) {
    createRoot(el).render(
      <ToastProvider>
        <App {...props} />
        {import.meta.env.DEV && <Agentation endpoint="http://localhost:4747" />}
      </ToastProvider>,
    )
  },
})
